import { BaseService } from './common/baseService';

export interface ProductCategory {
  id: string;
  name: string;
  description?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  created_by?: string;
  updated_by?: string;
}

export interface CreateProductCategoryData extends Record<string, unknown> {
  name: string;
  description?: string;
  is_active?: boolean;
}

export interface UpdateProductCategoryData extends Partial<CreateProductCategoryData> {
  id: string;
}

class ProductCategoriesService extends BaseService {
  constructor() {
    super('product_categories');
  }

  async getProductCategories(): Promise<ProductCategory[]> {
    return this.getAll<ProductCategory>({
      filters: { is_active: true },
      orderBy: { column: 'name', ascending: true }
    });
  }

  async getAllProductCategories(): Promise<ProductCategory[]> {
    return this.getAll<ProductCategory>({
      orderBy: { column: 'name', ascending: true }
    });
  }

  async getProductCategoryById(id: string): Promise<ProductCategory | null> {
    return this.getById<ProductCategory>(id);
  }

  async createProductCategory(categoryData: CreateProductCategoryData): Promise<ProductCategory> {
    return this.create<ProductCategory>(categoryData);
  }

  async updateProductCategory({ id, ...updateData }: UpdateProductCategoryData): Promise<ProductCategory> {
    return this.update<ProductCategory>(id, updateData);
  }

  async deleteProductCategory(id: string): Promise<void> {
    return this.delete(id);
  }

  async deactivateProductCategory(id: string): Promise<ProductCategory> {
    return this.update<ProductCategory>(id, { is_active: false });
  }

  async activateProductCategory(id: string): Promise<ProductCategory> {
    return this.update<ProductCategory>(id, { is_active: true });
  }
}

export const productCategoriesService = new ProductCategoriesService();